/**
 * `EmptyState` : un titre, une phrase, rien d'autre.
 *
 * Volontairement **sans action** : un état vide qui propose un bouton propose presque toujours un
 * bouton qui ne fait rien encore. Quand une action existera vraiment, elle sera passée par
 * `children` — jamais fabriquée ici.
 */
import type { JSX, ReactNode } from 'react';

export interface EmptyStateProps {
  title: string;
  hint?: string;
  children?: ReactNode;
}

export function EmptyState({ title, hint, children }: EmptyStateProps): JSX.Element {
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        padding: '32px 24px',
        textAlign: 'center',
      }}
    >
      <p style={{ margin: 0, fontSize: 14, fontWeight: 600, color: 'var(--ink-2)' }}>{title}</p>
      {hint === undefined ? null : (
        <p
          style={{
            margin: 0,
            maxWidth: 380,
            fontSize: 12.5,
            lineHeight: 1.5,
            color: 'var(--muted)',
          }}
        >
          {hint}
        </p>
      )}
      {children}
    </div>
  );
}
